import { render, staticRenderFns } from "./DataTableByCoa.vue?vue&type=template&id=2c4127b8"
import script from "./DataTableByCoa.vue?vue&type=script&lang=js"
export * from "./DataTableByCoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports